import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { t as typy } from 'typy'

import CategoryHeader from 'src/components/Category/CategoryHeader'
import ProductGrid from 'src/components/ProductGrid/ProductGrid'
import SEO from 'src/components/SEO/SEO'
import { getLocalizedCategoryData, getCategoryBySlug } from 'src/utils/category'
import { getProductsByIdsAndBrand } from 'src/utils/product'
import Brand from 'src/stores/brand'
import { getBrandById } from 'src/utils/brand'

type Props = {
  pageContext: any
  brand: Brand
}

@inject('brand')
@observer
class BrandCategory extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    const { brand, pageContext } = this.props

    brand.setBrandHeader(pageContext.brandId, false)
  }

  render(): JSX.Element {
    const { pageContext } = this.props
    const { category, brandId, headerImage, locale } = pageContext

    const products = getProductsByIdsAndBrand(category.products, brandId)
    const brand = getBrandById(brandId)
    let parentCat = null
    let parentLink
    let localizedParentCat = null
    if (category.inCategory) {
      parentCat = category.completeUri.split('/')[0]
      parentCat = getCategoryBySlug(parentCat)
      localizedParentCat = getLocalizedCategoryData(parentCat, locale)

      if (parentCat) {
        parentLink = `${brand.slug}/${parentCat.completeUri}`
      }
    }

    const {
      metaDescription,
      metaTitle,
      metaKeywords,
      name,
    } = getLocalizedCategoryData(category, locale)

    const fallbackColor = brand ? brand.fallbackColor : null
    const image = headerImage
      ? typy(headerImage, 'image.fields.file.url').safeObject
      : null

    return (
      <div className="brandTop">
        <SEO
          seoMetaDescription={metaDescription}
          seoOgimage={image}
          seoTitle={metaTitle ? metaTitle : `${brand.brand} - ${name}`}
        />
        <CategoryHeader
          title={name}
          mainCat={localizedParentCat}
          mainLink={parentLink}
          description={metaDescription}
          background={fallbackColor}
          image={image}
        />
        <ProductGrid products={products} />
      </div>
    )
  }
}

export default BrandCategory
